<template>
	<div class="landingpage">
		<div class="grid-container">
			<div class="grid-x grid-margin-x">
				<!-- Headings -->
				<div class="cell small-12">
					<h3>{{ $t('upsell.addedToCartTitle') }}</h3>
					<br />
					<h5 v-html="$t('upsell.addedToCartText')"></h5>
				</div>
				<div class="cell small-12 medium-12 large-12">
					<BookingMenu
						ref="bookingMenu"
						:class="{
							'booking-menu--active': true,
							'booking-menu--static': true
						}"
					/>
				</div>
			</div>
		</div>
		<!--<div class="landingpage__up-sell">
			<div class="grid-container">
				<div class="grid-x grid-margin-y grid-margin-x">
					<div class="cell small-12 medium-12 large-8">
						<h3 class="landingpage__title">{{ $t('upsell.upSellTitle') }}</h3>
					</div>
					<div class="cell small-12 landingpage__background">
						<div class="skirental-card grid-x grid-margin-x">
							<UpSellCard
								v-for="item in products"
								:cardData="item"
								:key="item.ages[0].poollid"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>-->
	</div>
</template>

<script>
import store from '../vueX/store'
import BookingMenu from '../components/molecules/BookingMenu'
import moment from 'moment'

export default {
	name: 'LandingPage',
	store,
	components: {
		BookingMenu
	},
	data: () => {
		return {
			loading: false,
			products: []
		}
	},
	methods: {
		getLongestPeriod() {
			let periods = []
			let products = store.state.cart

			if (products.skipass.length > 0) {
				products.skipass.forEach(item => {
					if (item.length > 0) {
						const newEndDate = moment(item.startDate)
							.add(item.length, 'days')
							.format('YYYY-MM-DD')
						periods.push({
							startDate: item.startDate,
							endDate: newEndDate,
							days: item.length
						})
					}
				})
			}

			if (products.skirental.length > 0) {
				products.skirental.forEach(item => {
					if (!item.isForSale) {
						const days = moment(item.endDate).diff(
							moment(item.startDate),
							'days'
						)
						periods.push({
							startDate: item.startDate,
							endDate: item.endDate,
							days: days
						})
					}
				})
			}

			if (products.skischool.length > 0) {
				products.skischool.forEach(item => {
					const days = moment(item.endDate).diff(moment(item.startDate), 'days')
					periods.push({
						startDate: item.startDate,
						endDate: item.endDate,
						days: days
					})
				})
			}
			if (periods.length > 0) {
				const longestPeriod = periods.reduce((max, item) =>
					max.days > item.days ? max : item
				)
				return [longestPeriod.startDate, longestPeriod.endDate]
			} else {
				return ['', '']
			}
		}
	},

	created: function () {
		/*store
			.dispatch('GET_UPSELL', {
				fromdate: this.getLongestPeriod()[0],
				todate: this.getLongestPeriod()[1]
			})
			.then(success => {
				if (success) {
					this.products = [...success]
					this.loading = false
				} else {
					this.loading = false
				}
			})*/
	}
}
</script>

<style scoped lang="scss">
.landingpage {
	&__title {
		margin-top: 40px;
	}
	&__up-sell {
		background-color: $colorPrimary1;
		margin-top: 20px;
	}
	&__background {
		background: $colorWhite;
	}
}
</style>
